const siteFormsModule = {
  state: {
    items: null,
    pagination: null,
    params: null
  },
  mutations: {
    setSiteForms (state, data) {
      state.items = data
    },
    setSiteFormsPagination (state, data) {
      state.pagination = data
    },
    setSiteFormsParams (state, data) {
      state.params = data
    },
  },
  getters: {
    getSiteForms: (state) => {
      return state.items
    },
    getSiteFormById: (state) => (form_id) => {
      let index = state.items.findIndex(function(item) {
        if(item.id === form_id) return true
        else return false
      })
      if(index !== -1) {
        return state.items[index]
      }
      else {
        return null
      }
    },
    getSiteFormsPagination: (state) => {
      return state.pagination
    },
    getSiteFormsParams: (state) => {
      return state.params
    }
  }
}

export default siteFormsModule



// WEBPACK FOOTER //
// ./src/store/modules/site_forms.js